import { DIALOG_960 } from 'components/modals/dialogWidths';
import { useModal } from 'components/modals/useModal';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { InvoiceData } from 'types/invoices';
import PaymentDistributionModal, { PAYMENT_DISTRIBUTION_MODAL_STYLE } from './PaymentDistributionModal';

/** The same page of another invoice: the case or contact the invoice was opened under and its tab are kept. */
export function invoicePathFor(pathname: string, invoiceId: number): string {
    return pathname.replace(/\/invoice\/\d+/, `/invoice/${invoiceId}`);
}

/** Opens the payment distribution of the invoice's shared-payment group from any copy of it. */
export function usePaymentDistributionModal(invoice: InvoiceData | undefined) {
    const { openModal, closeModal } = useModal();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return useCallback(() => {
        if (!invoice) {
            return;
        }
        openModal(
            <PaymentDistributionModal
                invoiceId={invoice.id}
                onClose={closeModal}
                // The deleted copy's page is gone; the page carries on with a copy that is left, the dialog over it.
                onOpenInvoiceDeleted={(nextInvoiceId) =>
                    navigate(invoicePathFor(pathname, nextInvoiceId), { replace: true })
                }
            />,
            closeModal,
            PAYMENT_DISTRIBUTION_MODAL_STYLE,
            undefined,
            DIALOG_960
        );
    }, [closeModal, invoice, navigate, openModal, pathname]);
}
